import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import {NotificationListAPI} from "./../../API/Caller/NotificationAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";


const Notification = () =>{

    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    
    const perpagedata = 15;


    useEffect(() => {

        NotificationListAPI(setNotifications, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Notifications</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">

                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Created On</th>
                                                <th>Lead Name</th>
                                                <th>Email</th>
                                                <th>Contact</th>
                                                <th>Schedule Date & Time</th>
                                                <th>Call Status</th>
                                                {/*<th className="text-end">Action</th>*/}
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="6">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (notifications && notifications.length > 0  ? 
                                                ( notifications.map(notification => 
                                                    (
                                            
                                                        <tr key={notification.id}>
                                                            <td>{moment(notification.created_at).format('DD-MM-YYYY h:mm:ss')}</td>
                                                            <td>{notification.leaddata.name}</td>
                                                            <td>{notification.leaddata.email}</td>
                                                            <td>{notification.leaddata.contact}</td>
                                                            <td>{moment(notification.display_date).format('DD-MM-YYYY')} {notification.display_time}</td>
                                                            <td>
                                                                {notification.subdispositiondata !== "" && notification.subdispositiondata !== null ?
                                                                    (notification.subdispositiondata.name)
                                                                :
                                                                    <>-</>
                                                                }

                                                            </td>
                                                            {/*<td className="text-end">
                                                                <Link to="" class="btn btn-dark btn-sm">
                                                                    <i className="ti ti-pencil"></i> Edit
                                                                </Link>
                                                                <button type="button" class="btn btn-danger btn-sm">
                                                                    <i className="ti ti-trash"></i> Delete
                                                                </button>													
                                                            </td>*/}
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="6">
                                                        <center><p>No record found...</p></center>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="row pagination-section">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>

    </div>
    )
}

export default Notification;